import { Devider, Flex, Text } from 'dash-ui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

export type LicenseData = {
  Name: string;
  'Name Type': string;
  'License Number/ Rank': string;
  'License Type': string;
  'Status/Expires': string;
  message?: string;
};

export const LicenseDataBox = ({
  licenseData,
}: {
  licenseData: LicenseData;
}) => {
  const theme = useTheme();
  const { t } = useTranslation(['forms', 'pages', 'common']);
  const handleColor = useCallback((status: string) => {
    if (status.includes('Active')) return theme.colors.g20;
    if (status.includes('Inactive') || status.includes('Void'))
      return theme.colors.r20;
    return undefined;
  }, []);
  return (
    <Flex flexDirection="column">
      <Text semibold>{t('pages:brokersPage.licenseData')}</Text>
      <Devider w="100%" h={4} color={theme.colors.n30} />
      {licenseData.message ? (
        <Text>{licenseData.message}</Text>
      ) : (
        <>
          <Text>
            <b>Name: </b> {licenseData['Name']}
          </Text>
          <Text>
            <b>License Type: </b> {licenseData['License Type']}
          </Text>
          <Text color={handleColor(licenseData['Status/Expires'])}>
            <b>Status: </b> {licenseData['Status/Expires']}
          </Text>
        </>
      )}
    </Flex>
  );
};
